module.exports = __webpack_public_path__ + "img/banner5.690de729.jpg";